module.exports = __webpack_public_path__ + "static/media/pid_profiler_initial.5b02ede7.svg";